"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_COLORS = void 0;
exports.PLAYER_COLORS = ['red', 'green', 'yellow', 'blue', 'black', 'purple', 'orange', 'pink'];
const ALL_COLORS = [...exports.PLAYER_COLORS, 'neutral', 'bronze'];
